module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fzoNy"))).then(() => parcelRequire('hEqeo'));